import type { ResourceName } from '@domain/types/entity';

export const isTemplateResource = (resourceName?: ResourceName) => resourceName === 'templates';
